<!--
 * @Description:服务项目配置服务事项
 * @Author:sunhuihong
 * @Date: 2022-05-26 08:28:58
 * @LastEditTime: 2024-05-27 09:09:14
-->
<template>
  <div>
    <el-form class="form" :model="hserviceMatter" ref="hserviceMatterForm" :rules="rules">
      <el-row style="margin: 30px 25px; padding-top: 20px;" :gutter="0" type="flex" justify="space-between">
        <el-col :span="16" style="position: relative;">
          <div style="margin-bottom: 20px;" >
            <span class="title-tag"></span>
            <span class="title-content">{{type == 1 ? '注意事项' : '其他'}}</span>
          </div>
          <el-popover ref="popover" placement="bottom" trigger="click" >
            <el-cascader-panel ref="cascader" :options="importHsvcTreeData" :props="defaultProps" 
              @change="handleChangeContent" v-model="selectedOptions">
            </el-cascader-panel>
            <el-button type="text" slot="reference"  style="position: absolute; right: 5px; top: 0; color: #3A7FF3;" 
              :disabled="readonly"  @click="handleImportServiceContent">
              选择模板
            </el-button>          
          </el-popover>         
          <el-form-item prop="content">
            <el-input placeholder="请输入" v-model="hserviceMatter.content" @keyup.native="handleInputServiceCotent" 
              :disabled="readonly" :readonly="readonly" minlength="1" maxlength="499" type="textarea" 
              ref="hserviceMatterContent" :rows="4"  >
            </el-input>
          </el-form-item>
          <div >
            <span class="title-tag"></span>
            <span class="title-content">服务标准及保障</span>
            <el-input  style="margin: 20px 0;" placeholder="请输入" v-model="matterCfg[1].content" disabled  
              type="textarea" :rows="6" ref="service">
            </el-input>
          </div>
          <div >
            <span class="title-tag"></span>
            <span class="title-content">预约须知</span>
            <el-input  style="margin: 20px 0;" placeholder="请输入" v-model="matterCfg[2].content" disabled  
              type="textarea" :rows="6" ref="booking">
            </el-input>
          </div>
        </el-col>
        <el-col :span="6" >
          <div style="height: 1100px; overflow-y: scroll;">
            <img style="width:100%;" src="@/assets/hsvccfg/app.png"  alt="">
          </div>
        </el-col>
      </el-row>
    </el-form>   
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>

<script>
import hsvcCfgDetailStore from './HsvcCfgDetailStore.js';
import Constant from '@/global/Constant.js'

let HsvcCfgServiceItemsPanel= {
  name: 'HsvcCfgServiceItemsPanel',
  hsvcCfgDetailStore,
  
  data() {
    let validateHsvcCfgContent = (_rule, _value, callback) => {
			if (this.hserviceMatter.content && this.hserviceMatter.content.trim().length == 0) {
				callback(new Error('注意事项不能输入全空格或全换行'));
			} else if (this.hserviceMatter.content == '') {
				callback(new Error('请输入注意事项'));
			} else {
        callback();
      }
    };

    return {
      btnStatus: {'prev': true, 'next': true, 'submit': false}, 
      selectedOptions: [],//选中的节点值，用于回显
      code: '',
      importHsvcTreeData: [],
      dataList: null,
      defaultProps: {
        value: 'id',
        children: 'matterCfgDTOList',
        label: 'name',
      },
      rules: {
        content: [
          { required: true, validator: validateHsvcCfgContent, trigger: ['blur', 'change']},
        ]
      } 
    }
  },

  computed: {
    mode() {
      return hsvcCfgDetailStore.state.mode;
    },
  
    hserviceMatter() {
      return hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0];
    },

    matterCfg(){
      return hsvcCfgDetailStore.state.matterCfgBaseInfoDO;
    },
    
    type() {
      return hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0].type;   
    },

    readonly() {
      return hsvcCfgDetailStore.state.mode == 'details';
    }  
  },

  methods: {
    //输入框输入服务事项
    handleInputServiceCotent(target) {
      if (target) {
        hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0].content = this.$refs.hserviceMatterContent.value;
      } else {
        hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0].content = '';
      }
    },

    //点击系统导入服务事项
    //因为总事项里面含有服务安全与保障，预约须知内容，不可更改，所以导入得时候不需要还出现，因此过滤不显示）
    //id:1 为服务安全与保障 id:3 为预约须知
    handleImportServiceContent() {  
      for(let i = 0; i < this.dataList.length; i++){
        if (this.dataList[i].id == 3 || this.dataList[i].id == 1) {
          this.dataList.splice(i,2);
        }
      }
      this.importHsvcTreeData = this.dataList;
    },

    //获取系统导入服务事项总数据
    getImportServiceData() {
      let header = this.encryptionUtil.signatureParams({},
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_TREE_MATTER_CFGS,
        param: {},
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.dataList = this.getTreeData(result.data);
          this.getServingSafetyData(this.dataList);
          this.getOrderKnowData(this.dataList);
        }
      });
    },

    //获取服务安全与保障内容，自动填充上不可修改
    getServingSafetyData(dataList) {
      let servingSafetyData =  dataList.find(item => {return item.id == 1});
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[1].content = servingSafetyData.matterCfgDTOList[0].content;
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[1].hserviceCfgId = servingSafetyData.matterCfgDTOList[0].id;
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[1].type = 2;
    },

    //获取预约须知内容，自动填充上不可修改
    getOrderKnowData(dataList) {
      let oderKnowData = dataList.find(item => {return item.id == 3});
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[2].content = oderKnowData.matterCfgDTOList[0].content;
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[2].hserviceCfgId = oderKnowData.matterCfgDTOList[0].id;
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO[2].type = 3;
    },

    handleChangeContent (value) {
      if (value.length > 0) {
        let checkNode = this.$refs['cascader'].getCheckedNodes()[0]
        hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0].content = checkNode.data.content;
        hsvcCfgDetailStore.state.matterCfgBaseInfoDO[0].hserviceCfgId = checkNode.data.id;
      }
      this.$refs["popover"].doClose();
    },

     //判断列表，把最后的children设为undefined
     //(children若为空数组，则将children设为undefined,children若不为空数组则继续 递归调用 本方法)
    getTreeData(data) {
      for(let item of data) {
        if (item.matterCfgDTOList == null || item.matterCfgDTOList.length == 0) {
          item.matterCfgDTOList = undefined;
        } else {
          this.getTreeData(item.matterCfgDTOList);
        }
      }
      return data;
    },

    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next') {
        this.$emit("panel-operate", operate);
        return true;
      }      
      this.$refs.hserviceMatterForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },
  }, 
  
  created() {
    this.getImportServiceData();
    if (this.mode == 'add') {
      hsvcCfgDetailStore.state.matterCfgBaseInfoDO.push(
        {content: '', hserviceCfgId: '', id: '', type: ''},
        {content: '', hserviceCfgId: '', id: '', type: ''}
    );
  }
 },

  destroyed() {
    //销毁的时候同步数据
    hsvcCfgDetailStore.commit('changeMatterCfgBaseInfoDO', this.matterCfg);
  },
}
export default HsvcCfgServiceItemsPanel
</script>

<style scoped>
.title-tag {
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #2A97FF;
  border-radius: 2px;
  margin-right: 9px;
  vertical-align: middle;
} 

.title-content {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  vertical-align: middle;
}

.form {
  margin-bottom: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/hsvccfg/components/hsvcCfgDetails/HsvcCfgServiceItemsPanel.vue